class SourceCollection extends Backbone.Collection
  url: 'offline/picklist'

module.exports = SourceCollection
